import { salesReportVariantRoutes } from './salesReportVariantRoutes'

export const isSalesReportRouteValid = (route: string, organizationUrl: string | undefined): boolean =>
  !!organizationUrl &&
  salesReportVariantRoutes.some((salesReportRoute) => route === salesReportRoute.getVariantRoute(organizationUrl))
